var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('button',{on:{"click":_vm.gtagTest1}},[_vm._v("Test link 1")]),_vm._v(" "),_c('button',{on:{"click":_vm.gtagTest2}},[_vm._v("Test link 2")]),_vm._v(" "),_c('button',{on:{"click":_vm.gtagTest3}},[_vm._v("Test link 3")]),_vm._v(" "),_c('button',{on:{"click":_vm.gtagTest4}},[_vm._v("Test link 4")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12354e59","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/TestPage.vue
// module id = null
// module chunks = 